import React from 'react';
import { observer } from 'mobx-react-lite';
import { useFlags } from 'launchdarkly-react-client-sdk';

import HomePageRedesign from './home-page-redesign';
import { HomeMenuProvider } from './home-menu-context';
import { HomeCmsContent } from './home-cms-content';

/**
 * The global homepage (`/`).
 *
 * On a Dutchie-hosted, multi-store enterprise domain, getServerSideProps
 * (get-home-server-side-props) resolves the hostname → enterprise and defaults
 * the visitor into their nearest store by geolocation (or the configured default
 * location, C3). When that resolves, we establish the homepage menu context and
 * render the enterprise's CMS-authored homepage (targeted by the resolved
 * dispensaryId), falling back to the generic marketplace homepage when nothing is
 * published. Otherwise (plain marketplace homepage) we render the generic
 * homepage unchanged. See ECOMM-11826.
 */
function IndexPage({ enterpriseId = null, resolvedDispensaryId = null }) {
  const flags = useFlags();
  const showShopLocal = !!flags?.['growth.ecomm.homepage-v3.show-shop-local'];

  const genericHomepage = <HomePageRedesign showShopLocal={showShopLocal} />;

  if (enterpriseId && resolvedDispensaryId) {
    return (
      <HomeMenuProvider enterpriseId={enterpriseId} dispensaryId={resolvedDispensaryId}>
        <HomeCmsContent fallback={genericHomepage} />
      </HomeMenuProvider>
    );
  }

  return genericHomepage;
}

export default observer(IndexPage);
